import React from 'react';
import { SVGProps } from 'react';

const AddIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="Add-History" transform="matrix(3.26667,0,0,3.26667,-734,-2560.07)">
            <g id="Add-Icon">
                <g transform="matrix(0.588235,0,0,0.625,92.6471,294)">
                    <path
                        d="M276,796C276,789.377 270.287,784 263.25,784L237.75,784C230.713,784 225,789.377 225,796L225,820C225,826.623 230.713,832 237.75,832L263.25,832C270.287,832 276,826.623 276,820L276,796Z"
                        style={{ fill: '#72BF00' }}
                    />
                </g>
                <g id="Plus">
                    <g transform="matrix(0.655977,0,0,1.10149,80.2697,-86.1333)">
                        <rect x="240" y="793.156" width="7" height="20.844" style={{ fill: 'white' }} />
                    </g>
                    <g transform="matrix(4.0167e-17,0.655977,-1.10149,6.74468e-17,1125.13,639.27)">
                        <rect x="240" y="793.156" width="7" height="20.844" style={{ fill: 'white' }} />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default AddIcon;
